import { ApolloProvider } from '@apollo/react-hooks';
import * as Sentry from '@sentry/browser';
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import StyleOverrides from 'src/App/StyleOverrides';
import ViewportMeta from 'src/App/ViewportMeta';
import env from 'src/env';
import Braze from 'src/services/brazeService';
import { ThemeProvider } from 'styled-components';
import client from './apolloClient';
import DesignProLayout from './components/DesignPro/DesignProLayout';
import store, { history } from './store/configureStore';
import theme from './theme';

if (env.SENTRY_DSN) {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: env.APP_ENVIRONMENT,
    release: env.APP_VERSION,
    ignoreErrors: [
      'Non-Error exception captured', // see https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/13
      'Non-Error promise rejection captured', // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/13

      // ---------------------------------
      // Sentry recommended block list https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
      // ---------------------------------
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
    ],
    blacklistUrls: [
      // ---------------------------------
      // Sentry recommended block list https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
      // ---------------------------------
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
  });
}

if (Braze.isEnabled()) {
  Braze.initialize();
}

export default function Providers() {
  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ConnectedRouter history={history}>
            <>
              <StyleOverrides />
              <ViewportMeta />
              <Switch>
                <Route
                  path="/:jobId/model/:modelId"
                  component={DesignProLayout}
                />
                <Route path="/:jobId" component={DesignProLayout} />
              </Switch>
            </>
          </ConnectedRouter>
        </ThemeProvider>
      </Provider>
    </ApolloProvider>
  );
}
